import React from 'react'
import { connect } from 'react-redux'
import { Grid, Col, Row } from 'react-bootstrap'

import ShoppingCart from '../../components/shoppingCart'
import CheckoutContent from '../../workflow/checkout/checkoutContent'
import Header from '../../components/header'
import Footer from '../../components/footer'
//import { loadWorkShopData } from "../../workflow/checkout/workshop/actions"
import { configuration } from "../../configuration"
import { getRecallsByVin } from '../../requesters/recalls'

import './styles.css'

class ClientContainer extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            make: null,
            model: null,
            recalls: []
        }

    }

    componentWillReceiveProps(props) {
        if (props.currentUser) {
            this.setState({ make: props.currentUser.make, model: props.currentUser.model });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.carData && prevProps.carData !== this.props.carData) {
            this.loadRecallsByVin()
        }
    }
    
    loadRecallsByVin = () => {
        const car = this.props.carData

        if (car && car.carVin) {
            getRecallsByVin(car.carVin)
                .then(response => {
                    let recalls = response.data.map(item => item.description)
                    this.setState({ recalls: recalls })
                })
        }
    }

    render() {
        var title = '';
        if (this.props.carData && this.props.carData.carMake && this.props.carData.carModel) {
            if (configuration().engineField === 'Modelo') {
                let engine = this.props.carData.carEngine.split(',')[0]
                title = (<h2 className='checkout-title'>
                    Cuéntanos qué necesita tu {this.props.carData.carMake} {engine}</h2>)
            } else {
                title = (<h2 className='checkout-title'>
                    {configuration().hideMake
                        ? 'Cuéntanos qué necesita tu ' + this.props.carData.carModel
                        : 'Cuéntanos qué necesita tu ' + this.props.carData.carMake + ' ' + this.props.carData.carModel}</h2>)
            }
        } else if (this.state.make && this.state.model) {
            title = (<h2 className='checkout-title'>
                Cuéntanos qué necesita tu {this.state.make} {this.state.make}</h2>)
        } else {
            title = (<h2 className='checkout-title'>{configuration().brandName == 'Mazda' &&
                this.props.carData && this.props.carData.carModel
                ? 'Cuéntanos un poco más acerca de tu ' + this.props.carData.carModel
                : 'Cuéntanos un poco más acerca de tu ' + configuration().coche}</h2>)
        }
        return (
            <div className="select-plan">
                <Header />
                <div className="bubocar-img-header"
                    style={{ backgroundImage: 'url(' + configuration().backgroundImage + ')' }} />
                <Grid>
                    {title}
                    <Row className="show-grid">
                        <Col xs={12} lg={8}>
                            <CheckoutContent recalls={this.state.recalls} />
                        </Col>
                        <Col xs={12} lg={4}>
                            <div className="blockContainer">
                                <ShoppingCart recalls={this.state.recalls} />
                            </div>
                        </Col>

                    </Row>
                </Grid>
                <Footer />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    queryParams: state.checkout.checkoutRoot.queryParams,
    tokenStatus: state.checkout.checkoutRoot.tokenStatus,
    nonForfaitBudget: state.checkout.checkoutRoot.nonForfaitBudget,
    currentUser: state.checkout.checkoutContent.currentUser,
    clientCarPlate: state.checkout.carData.clientCarPlate,
    carData: state.checkout.carData.carDataData,
    workshop: state.checkout.workshop,
})

const bindActions = dispatch => ({
    //loadWorkShopData: emailHash => dispatch(loadWorkShopData(emailHash)),
})

export default connect(mapStateToProps, bindActions)(ClientContainer)



// WEBPACK FOOTER //
// ./src/containers/clientContainer/index.js